import { useEffect, useState } from 'react';

function normalize(hash) {
  const raw = (hash || '').replace(/^#/, '');
  const path = raw.startsWith('/') ? raw : `/${raw}`;
  return path === '/' ? '/home' : path;
}

export default function useHashRoute() {
  const [route, setRoute] = useState(() => normalize(window.location.hash));
  const [isLoading, setIsLoading] = useState(false);
  const [pendingRoute, setPendingRoute] = useState(null);

  useEffect(() => {
    const handleNavigationStart = () => {
      setIsLoading(true);
    };

    const handleNavigationEnd = () => {
      const newRoute = normalize(window.location.hash);
      setRoute(newRoute);
      setPendingRoute(null);
      
      // Stop loading after a delay to ensure smooth transition
      setTimeout(() => {
        setIsLoading(false);
      }, 2000); // 2000ms delay for smooth transition
    };

    // Initial load - don't auto-hide loading on initial render
    if (window.location.hash) {
      const initialRoute = normalize(window.location.hash);
      if (initialRoute !== '/home') {
        setIsLoading(true);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000); // Hide initial loading after 1000ms
      }
    }

    // Set up event listeners
    window.addEventListener('hashchange', handleNavigationStart);
    const hashChangeListener = () => {
      handleNavigationEnd();
    };
    window.addEventListener('hashchange', hashChangeListener);

    return () => {
      window.removeEventListener('hashchange', handleNavigationStart);
      window.removeEventListener('hashchange', hashChangeListener);
    };
  }, [pendingRoute]);

  const navigate = (path) => {
    const targetPath = path.startsWith('#') ? path.slice(1) : path;
    if (targetPath !== route.replace(/^\//, '')) {
      setIsLoading(true);
      setPendingRoute(targetPath);
      window.location.hash = targetPath;
        
      // Fallback in case hashchange doesn't fire
      setTimeout(() => {
        if (isLoading) {
          setIsLoading(false);
        }
      }, 5000);
    }
  };

  return { route, navigate, isLoading };
}
